import {
  Brand20,
  Brand60,
  ModelBrandEquity,
  ModelBrandEquitySoft,
  ModelCommerce,
  ModelCommerceSoft,
  ModelGeo,
  ModelGeoSoft
} from '../../../utils/colors';
import { ModelType, ModelTypeType } from './data-qa-constants';

export interface ModelColor {
  fg: string;
  bg: string;
}

// Model-type identity palette for the multi-model capsules, sourced entirely
// from design-system tokens (see the "MMM model-type identity palette" block in
// src/utils/colors.ts). `fg` is the strong ink, `bg` the soft tint fill.
export const MODEL_TYPE_COLORS: Record<ModelTypeType, ModelColor> = {
  [ModelType.DTC]: { fg: Brand60, bg: Brand20 },
  [ModelType.COMMERCE]: { fg: ModelCommerce, bg: ModelCommerceSoft },
  [ModelType.GEO]: { fg: ModelGeo, bg: ModelGeoSoft },
  [ModelType.BRAND_EQUITY]: { fg: ModelBrandEquity, bg: ModelBrandEquitySoft }
};

export const modelTypeColor = (modelType: ModelTypeType): ModelColor =>
  MODEL_TYPE_COLORS[modelType] ?? MODEL_TYPE_COLORS[ModelType.DTC];
